import React, { useContext, useRef, useState } from "react";
import { Box, Typography, Switch, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { motion, AnimatePresence } from "framer-motion";
import { MainContext } from "../App";

// Props:
// open, onClose
// enabled, onToggleEnabled(next:boolean)
// message, subtext?, imageSrc
// onClick (open MailModal), durationMs (default 3000)
// onHoverPauseChange?(paused:boolean)  // optional hook to manager
export default function MailToast({
  open,
  onClose,
  enabled,
  onToggleEnabled,
  onClick,
  message = "You got mail",
  subtext = "",
  imageSrc = require("../@shared/assets/icons/mail_icon.png"),
  durationMs = 3000,
  onHoverPauseChange,
}) {
  const hovering = useRef(false);
  const {deviceType} = useContext(MainContext)

  const handleMouseEnter = () => {
    hovering.current = true;
    onHoverPauseChange?.(true);
  };
  const handleMouseLeave = () => {
    hovering.current = false;
    onHoverPauseChange?.(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.25 }}
          style={{
            position: "fixed",
            left: deviceType === 'desktop' ? "30%" : "0%",
            bottom: 28,
            zIndex: 3000,
            cursor: "pointer",
          }}
          transformTemplate={(t) => `translateX(-50%) ${t}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={onClick}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 2,
              py: 1.25,
              borderRadius: 2,
              bgcolor: "#0f0f1a",
              border: "1px solid #2c2c3f",
              boxShadow: "0 10px 30px rgba(0,0,0,0.45)",
              minWidth: {xs:300, md:380},        // bigger
              maxWidth: "92vw",
              position: "relative",
            }}
          >
            {/* Top-right toggle */}
            <Box sx={{ position: "absolute", top: 6, right: 8, display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography sx={{ color: "#9aa0b4", fontSize: 11, mr: 0.5 }}>
                Toasts
              </Typography>
              <Switch
                size="small"
                checked={enabled}
                onChange={(e) => onToggleEnabled(e.target.checked)}
                onClick={(e) => e.stopPropagation()}
              />
            </Box>

            {/* Left icon */}
            <Box sx={{ width: 44, height: 44, borderRadius: 1, overflow: "hidden", flexShrink: 0 }}>
              <img
                src={imageSrc}
                alt="mail"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </Box>

            {/* Text */}
            <Box sx={{ pr: 6 }}>
              <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: 16, lineHeight: 1.1 }}>
                {message}
              </Typography>
              {!!subtext && (
                <Typography sx={{ color: "#bdbdde", fontSize: 13, mt: 0.25 }} noWrap>
                  {subtext}
                </Typography>
              )}
            </Box>

            {/* Close */}
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              sx={{ position: "absolute", right: 6, bottom: 6, color: "#c8c8d6" }}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
